import Vue from 'vue'
import Api from '../../api/index'
import { removeSL } from '../../utils/tools'

const user = {
  state: {
    authorization: '',
    permissions: [],
    user: null,
    selfAreaId: '',
    selfAddress: '',
    areaAll: [],
    userCurrentPage: 10,
    level: 0,
    siteMessageLength: 0,
    historyData: [],
    fullPileNum: 1, // 满装值
    fullPileName: 'shenhe',
    sideBarLoading: false,
    platformCode: '', // 站点管理展示的 平台编号
    isAggregation: false, // 当前展示是否为复合区的子集，默认不是
    userSelectAddressData: undefined, // 保存当前用户选择的地址信息
    ratioSites: [], // 当前任务满桩值的站点列表
    illegalBikes: [], // 原始的非法车辆
    siteId: '',
    userBikeType: '' // 用户单车类型归属(0:自行车 1:电动车 2:包含自行车和电动车)
  },

  mutations: {
    setUserInfo: (state, payload) => {
      Vue.set(state, payload.key, payload.value)
    }
  },

  actions: {
    setSideBarLoading({ commit }, payload) {
      commit('setUserInfo', {
        key: 'sideBarLoading',
        value: payload.value
      })
    },
    getFullPileNum({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getFullPileNum(payload)
          .then(res => {
            // console.log(res)
            if (res.code === 200) {
              commit('setUserInfo', {
                key: 'fullPileNum',
                value: Number(res.data.data) || 1
              })
              commit('setUserInfo', {
                key: 'fullPileName',
                value: res.data.alias || '满桩值'
              })
            } else {
              console.log('user数据拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('getFullPileNum数据接口报错', err)
            reject(err)
          })
      })
    },
    getInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getInfo(payload)
          .then(res => {
            if (res.code === 200) {
              commit('setUserInfo', {
                key: 'user',
                value: res.data
              })
              commit('setUserInfo', {
                key: 'level',
                value: res.data.areaLevel
              })
              commit('setUserInfo', {
                key: 'userBikeType',
                value: res.data.bikeType
              })
              console.log('user数据拉取成功', res)
              resolve(res)
            } else {
              console.log('user数据拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('user数据接口报错', err)
            reject(err)
          })
      })
    },
    getInfoByLogin({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getInfo(payload)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              console.log('user数据拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('user数据接口报错', err)
            reject(err)
          })
      })
    },
    getPermission({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getPermission(payload)
          .then(res => {
            if (res.code === 200) {
              commit('setUserInfo', {
                key: 'permissions',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('用户权限拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('用户权限接口报错', err)
            reject(err)
          })
      })
    },
    // 权限为000000
    getAreaAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getAreaAll(payload)
          .then(res => {
            console.log(res,2222);
            if (res.code === 200) {
              res.data.unshift({
                aggregation: 0,
                aggregationId: '',
                areaCode: '000000',
                areaName: '全国',
                id: '000000',
                level: 0,
                parentId: '',
                platformCode: '000000'
              })
              commit('setUserInfo', {
                key: 'areaAll',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('用户区域范围拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('用户区域范围拉取接口报错', err)
            reject(err)
          })
      })
    },
    // 权限非000000
    getUserArea2({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: payload.selfAreaId,
          areaId: payload.areaId
        }
        Api.getUserArea2(params)
          .then(res => {
            if (res.code === 200) {
              if (payload.userAreaId === '000000') {
                res.data.unshift({
                  aggregation: 0,
                  aggregationId: '',
                  areaCode: '000000',
                  areaName: '全国',
                  id: '000000',
                  level: 0,
                  parentId: '',
                  platformCode: '000000'
                })
              }
              commit('setUserInfo', {
                key: 'areaAll',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('用户区域范围拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('用户区域范围拉取接口报错', err)
            reject(err)
          })
      })
    },
    getUserArea({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getUserArea(payload)
          .then(res => {
            if (res.code === 200) {
              commit('setUserInfo', {
                key: 'areaAll',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('用户区域范围拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('用户区域范围拉取接口报错', err)
            reject(err)
          })
      })
    },
    getArea({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.getArea(payload)
          .then(res => {
            if (res.code === 200) {
              commit('setUserInfo', {
                key: 'areaAll',
                value: res.data
              })
              resolve(res)
            } else {
              console.log('用户区域范围拉取失败', res)
              reject(res)
            }
          })
          .catch(err => {
            console.log('用户区域范围拉取接口报错', err)
            reject(err)
          })
      })
    },
    login({ commit }, data) {
      commit('setUserInfo', data) // authorization
      commit('setUserInfo', {
        key: 'user',
        value: null
      })
      commit('setUserInfo', { // main.js
        key: 'permissions',
        value: []
      })
      commit('setUserInfo', { // main.js
        key: 'selfAreaId',
        value: ''
      })
      commit('setUserInfo', { // main.js
        key: 'areaAll',
        value: []
      })
      commit('setUserInfo', { // main.js
        key: 'selfAddress',
        value: ''
      })
      commit('setUserInfo', { // main.js
        key: 'userSelectAddressData',
        value: undefined
      })
      commit('setUserInfo', { // main.js
        key: 'userBikeType',
        value: ''
      })
    },
    logout({ dispatch, commit, state, rootState }) {
      commit('setUserInfo', { // main.js
        key: 'user',
        value: null
      })
      commit('setUserInfo', {
        key: 'authorization',
        value: ''
      })
      commit('setUserInfo', { // main.js
        key: 'permissions',
        value: []
      })
      commit('setUserInfo', { // main.js
        key: 'selfAreaId',
        value: ''
      })
      commit('setUserInfo', { // main.js
        key: 'level',
        value: 0
      })
      commit('setUserInfo', { // main.js
        key: 'areaAll',
        value: []
      })
      commit('setUserInfo', { // main.js
        key: 'selfAddress',
        value: ''
      })
      commit('setUserInfo', { // main.js
        key: 'siteMessageLength',
        value: 0
      })
      commit('setUserInfo', { // main.js
        key: 'historyData',
        value: []
      })
      commit('setUserInfo', { // main.js
        key: 'userSelectAddressData',
        value: undefined
      })
      commit('setUserInfo', { // main.js
        key: 'userBikeType',
        value: ''
      })
      removeSL('VUEX:STATE')
    }
  }
}

export default user
